export const getCoexecutorNIRDates = (coexecutorData, step) => {
  // Check previous steps
  const stepIsFirst = () => {
    const result = [];

    // All prev steps must be false
    for (let i = 1; i < step - 1; i += 1) {
      result.push(coexecutorData.coexecutorsPersonId[`isStep${i}`]);
    }
    return result.every((el) => el === false);
  };
  switch (step) {
    case 1:
      return 'С даты заключения Договора до 30.06.2025 г. (включительно)';
    case 2:
      if (coexecutorData.coexecutorsPersonId.isStep1) return 'С даты подписания Получателем и Заказчиком Акта сдачи-приемки выполненных работ по 1 этапу Договора до 20.12.2025 г. (включительно)';
      if (stepIsFirst()) return 'С даты заключения Договора до 20.12.2025 г. (включительно)';
      return 'С 01.07.2025 г. (включительно) до 20.12.2025 г. (включительно)';
    case 3:
      if (coexecutorData.coexecutorsPersonId.isStep2) return 'С даты подписания Получателем и Заказчиком Акта сдачи-приемки выполненных работ по 2 этапу Договора до 30.06.2026 г. (включительно)';
      if (stepIsFirst()) return 'С даты заключения Договора до 30.06.2026 г. (включительно)';
      return 'С 10.01.2026 г. (включительно) до 30.06.2026 г. (включительно)';
    case 4:
      if (coexecutorData.coexecutorsPersonId.isStep3) return 'С даты подписания Получателем и Заказчиком Акта сдачи-приемки выполненных работ по 3 этапу Договора до 20.12.2026 г. (включительно)';
      if (stepIsFirst()) return 'С даты заключения Договора до 20.12.2026 г. (включительно)';
      return 'С 01.07.2026 г. (включительно) до 20.12.2026 г. (включительно)';
    case 5:
      if (coexecutorData.coexecutorsPersonId.isStep4) return 'С даты подписания Получателем и Заказчиком Акта сдачи-приемки выполненных работ по 4 этапу Договора до 30.06.2027 г. (включительно)';
      if (stepIsFirst()) return 'С даты заключения Договора до 30.06.2027 г. (включительно)';
      return 'С 10.01.2027 г. (включительно) до 30.06.2027 г. (включительно)';
    case 6:
      if (coexecutorData.coexecutorsPersonId.isStep5) return 'С даты подписания Получателем и Заказчиком Акта сдачи-приемки выполненных работ по 5 этапу Договора до 20.12.2027 г. (включительно)';
      if (stepIsFirst()) return 'С даты заключения Договора до 20.12.2027 г. (включительно)';
      return 'С 01.07.2027 г. (включительно) до 20.12.2027 г. (включительно)';
    default:
      return '';
  }
};

export const getCoexecutorSDates = (coexecutorData, step) => {
  switch (step) {
    case 1:
      return 'С даты заключения Соглашения до 20.12.2025 г. (включительно)';
    case 2:
      if (!coexecutorData.coexecutorsPersonId.isStep1 && !coexecutorData.coexecutorsPersonId.isStep2) return 'С даты заключения Соглашения до 20.12.2026 г. (включительно)';
      return 'С даты предоставления Грантополучателем надлежащим образом оформленного Финансового отчета, Аннотированного отчета и Акта сдачи-приемки выполненных Работ за 1 (Первый) этап выполнения Работ до 20.12.2026 г. (включительно)';
    case 3:
      if (!coexecutorData.coexecutorsPersonId.isStep3 && !coexecutorData.coexecutorsPersonId.isStep4) return 'С даты заключения Соглашения до 20.12.2027 г. (включительно)';
      return 'С даты предоставления Грантополучателем надлежащим образом оформленного Финансового отчета, Аннотированного отчета и Акта сдачи-приемки выполненных Работ за 2 (Второй) этап выполнения Работ до 20.12.2027 г. (включительно)';
    default:
      return '';
  }
};

